import React from 'react';
import { DragPreviewImage, useDrag } from 'react-dnd';
import ReactTooltip from 'react-tooltip';
import PropTypes from 'prop-types';

import CustomTooltip from '../../../componentLibrary/CustomTooltip';
import * as itemTypes from '../../../constants/itemTypes/itemTypes';
import imageSources from '../../../constants/imageSources/imageSources';
import * as Styled from './styles';
import { elementBorderColors } from '../../../constants/styleRules/styleRules';

const toolTipTags = {
    IMAGE: 'Image',
    PARAGRAPH: 'Text',
    BUTTON: 'Button',
    SPACER: 'Spacer',
    SOCIAL: 'Social Links',
    SURVEY: 'Survey',
    VIDEO: 'Video',
};

const DraggableElement = ({ index, type, tooltipPosition, isEnabled, disabledTooltipOffset }) => {
    const [{ isDragging, handlerId }, drag, dragPreview] = useDrag({
        type: itemTypes.STATIC_BLOCK_COLUMN_ITEM,
        item: () => {
            ReactTooltip.hide();
            return { itemType: type };
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
            handlerId: monitor.getHandlerId(), // https://github.com/react-dnd/react-dnd/issues/2774
        }),
    });

    return (
        <div ref={drag}>
            <DragPreviewImage connect={dragPreview} src={imageSources.ELEMENT_ICONS(type, true)} />
            <div
                data-tip
                data-for={type}
                data-handler-id={handlerId}
                style={{ height: 48 }}
                data-test-id={`${type.toLowerCase()}-element`}
            >
                <Styled.Div
                    isDragging={isDragging}
                    index={index}
                    imageSource={imageSources.ELEMENT_ICONS(type, false)}
                    border={elementBorderColors[type]}
                    isEnabled={isEnabled}
                    role="button"
                    aria-label={`Add ${toolTipTags[type]} element to canvas`}
                />
                {isEnabled ? (
                    <ReactTooltip id={type} place={tooltipPosition} effect="solid">
                        <Styled.TooltipText>{toolTipTags[type]}</Styled.TooltipText>
                    </ReactTooltip>
                ) : (
                    <CustomTooltip
                        dataRef={type}
                        place={tooltipPosition}
                        offset={disabledTooltipOffset}
                        text={`Request a full product demo to see the ${toolTipTags[type]} Element.`}
                    />
                )}
            </div>
        </div>
    );
};

DraggableElement.defaultProps = {
    disabledTooltipOffset: {},
};

DraggableElement.propTypes = {
    index: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    tooltipPosition: PropTypes.string.isRequired,
    isEnabled: PropTypes.bool.isRequired, // defaultProps true did not work since we are checking for the prop in DragSource
    disabledTooltipOffset: PropTypes.object,
};

export default DraggableElement;
